import WebFontLoader from 'webfontloader'

// async load fonts
WebFontLoader.load({
  google: {
    families: ['Roboto+Flex:opsz,wght@8..144,100..1000&display=swap'],
  },
})
